/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountStat
 */
export interface CountStat {
    /**
     * 
     * @type {string}
     * @memberof CountStat
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof CountStat
     */
    count: number;
}

/**
 * Check if a given object implements the CountStat interface.
 */
export function instanceOfCountStat(value: object): value is CountStat {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function CountStatFromJSON(json: any): CountStat {
    return CountStatFromJSONTyped(json, false);
}

export function CountStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountStat {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'count': json['count'],
    };
}

  export function CountStatToJSON(json: any): CountStat {
      return CountStatToJSONTyped(json, false);
  }

  export function CountStatToJSONTyped(value?: CountStat | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'count': value['count'],
    };
}

